export default __webpack_public_path__ + "static/screenshot-feature-importances-6cb0b4af040ef637d79a562562c52198.webp";